export const defaultServiceFamilies = {
    "3": {
        "id": "3",
        "name": {
            "fr": "Skipass",
            "en": "Skipass",
            "nl": "Skipas"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "4": {
        "id": "4",
        "name": {
            "fr": "Services Hôteliers",
            "en": "Hotel services",
            "nl": "Hotelservices"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "5": {
        "id": "5",
        "name": {
            "fr": "Panier de courses livré",
            "en": "Food Pack delivery",
            "nl": "Maaltijdpakket levering"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "6": {
        "id": "6",
        "name": {
            "fr": "Assurance manque de neige",
            "en": "Insurance Lack of Snow",
            "nl": "Verzekering Gebrek aan sneeuw"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "7": {
        "id": "7",
        "name": {
            "fr": "Vos Prestations",
            "en": "Service provisions",
            "nl": "Jouw services"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "8": {
        "id": "8",
        "name": {
            "fr": "Transport",
            "en": "Transport",
            "nl": "Busreis"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "11": {
        "id": "11",
        "name": {
            "fr": "Restauration",
            "en": "Restaurant & Board",
            "nl": "Restaurant"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "12": {
        "id": "12",
        "name": {
            "fr": "Ecole de Ski - Cours collectifs",
            "en": "Ski school - Group lessons",
            "nl": "Skischool ESF groepslessen"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "13": {
        "id": "13",
        "name": {
            "fr": "Activités Bien Etre",
            "en": "Wellbeing activities",
            "nl": "Welzijn activiteiten"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "14": {
        "id": "14",
        "name": {
            "fr": "Matériel de ski",
            "en": "Ski equipment",
            "nl": "Ski-/snowboardhuur"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "30": {
        "id": "30",
        "name": {
            "fr": "Casque",
            "en": "Helmet",
            "nl": "Helm"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "38": {
        "id": "38",
        "name": {
            "fr": "Offre spéciale",
            "en": "Special offer",
            "nl": "Speciale aanbieding"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "40": {
        "id": "40",
        "name": {
            "fr": "Activités Après-Ski",
            "en": "After Ski activities",
            "nl": "After Ski activiteiten"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "41": {
        "id": "41",
        "name": {
            "fr": "Sport",
            "en": "Sport",
            "nl": "Sport"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "42": {
        "id": "42",
        "name": {
            "fr": "Parc d'attractions",
            "en": "Theme park",
            "nl": "Pretpark"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "44": {
        "id": "44",
        "name": {
            "fr": "",
            "en": "",
            "nl": "Lazy Sunday"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "53": {
        "id": "53",
        "name": {
            "fr": "Matériel de ski",
            "en": "Ski equipment",
            "nl": "Ski-/snowboardhuur"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "54": {
        "id": "54",
        "name": {
            "fr": "Matériel de ski",
            "en": "Ski equipment",
            "nl": "Ski-/snowboardhuur"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "55": {
        "id": "55",
        "name": {
            "fr": "Matériel de ski",
            "en": "Ski equipment",
            "nl": "Ski-/snowboardhuur"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "56": {
        "id": "56",
        "name": {
            "fr": "Matériel de ski",
            "en": "Ski equipment",
            "nl": "Ski-/snowboardhuur"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "57": {
        "id": "57",
        "name": {
            "fr": "Matériel de ski",
            "en": "Ski equipment",
            "nl": "Ski-/snowboardhuur"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "63": {
        "id": "63",
        "name": {
            "fr": "Matériel de ski",
            "en": "Ski equipment",
            "nl": "Ski-/snowboardhuur"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "64": {
        "id": "64",
        "name": {
            "fr": "Ecole de Ski - Cours collectifs",
            "en": "Ski school",
            "nl": "Nederlandse groepslessen"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "65": {
        "id": "65",
        "name": {
            "fr": "Pass Multi-activités",
            "en": "Multi-activity pass",
            "nl": "Multi-activiteitenpas"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "66": {
        "id": "66",
        "name": {
            "fr": "Parc à thème",
            "en": "Theme park",
            "nl": "Pretpark"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "67": {
        "id": "67",
        "name": {
            "fr": "Bagagerie",
            "en": "Luggage storage",
            "nl": "Bagagerie"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "68": {
        "id": "68",
        "name": {
            "fr": "Animations & Evénement",
            "en": "Events & Entertainment",
            "nl": "Test & Ride Center"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "69": {
        "id": "69",
        "name": {
            "fr": "Parking",
            "nl": "Parkeren",
            "en": "Parking"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "ACCOMMODATION"
    },
    "70": {
        "id": "70",
        "name": {
            "fr": "Taxe de séjour",
            "en": "Tourist tax",
            "nl": "Toeristenbelasting"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "71": {
        "id": "71",
        "name": {
            "fr": "Vente sur place",
            "en": "Sold locally",
            "nl": "Verkoop ter plaatse"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "72": {
        "id": "72",
        "name": {
            "fr": "Activités Vélo",
            "en": "Biking activities",
            "nl": "Fiets activiteiten"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "73": {
        "id": "73",
        "name": {
            "fr": "Activités Eaux vives",
            "en": "Return Saturday night in Valley",
            "nl": "Wildwatersporten"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "74": {
        "id": "74",
        "name": {
            "fr": "Activités Grand-air & Rando",
            "en": "Hiking & Outdoor activities",
            "nl": "Wandelen- & outdooractiviteiten"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "75": {
        "id": "75",
        "name": {
            "fr": "Skipass famille",
            "en": "Skipass Family Pack",
            "nl": "Familie skipas"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "77": {
        "id": "77",
        "name": {
            "fr": "Sensations fortes et adrénaline",
            "en": "Adrenalin and sensation",
            "nl": "First Tracks"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    },
    "78": {
        "id": "78",
        "name": {
            "fr": "Transferts",
            "en": "Transfer",
            "nl": "Transfer"
        },
        "description": {
            "fr": ""
        },
        "image": "",
        "type": "PARTICIPANT"
    }
};